import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import userService from '../services/userService';

/**
 * Hook personalizado para acceder a la información del usuario
 * Proporciona acceso a roles, grupos, clearances y métodos de verificación
 */
export const useUser = () => {
  const auth = useAuth();
  const [userInfo, setUserInfo] = useState({
    user: null,
    roles: [],
    groups: [],
    clearances: [],
    effectiveClearance: null,
    isAuthenticated: false
  });

  // Actualizar la información del usuario cuando cambie el estado de autenticación
  useEffect(() => {
    if (auth.isAuthenticated && auth.user) {
      userService.initialize(auth.user);
      setUserInfo(userService.getUserInfo());
    } else {
      userService.reset();
      setUserInfo({
        user: null,
        roles: [],
        groups: [],
        clearances: [],
        effectiveClearance: null,
        isAuthenticated: false
      });
    }
  }, [auth.isAuthenticated, auth.user]);

  // Métodos de conveniencia para verificar permisos
  const hasRole = (role) => {
    return userService.hasRole(role);
  };

  const hasAnyRole = (roles) => {
    return userService.hasAnyRole(roles);
  };

  const hasGroup = (group) => {
    return userService.hasGroup(group);
  };

  const hasAnyGroup = (groups) => {
    return userService.hasAnyGroup(groups);
  };

  const hasClearance = (requiredClearance) => {
    return userService.hasClearance(requiredClearance);
  };

  const getClearanceLevel = (clearance) => {
    return userService.getClearanceLevel(clearance);
  };

  const getAllClearances = () => {
    return userService.getAllClearances();
  };

  return {
    // Información del usuario
    user: userInfo.user,
    isAuthenticated: userInfo.isAuthenticated,
    roles: userInfo.roles,
    groups: userInfo.groups,
    clearances: userInfo.clearances,
    effectiveClearance: userInfo.effectiveClearance,
    
    // Métodos de verificación
    hasRole,
    hasAnyRole,
    hasGroup,
    hasAnyGroup,
    hasClearance,
    getClearanceLevel,
    getAllClearances,
    
    // Información completa
    getUserInfo: () => userService.getUserInfo()
  };
};

export default useUser;
